import { useQuery } from "@apollo/client";

import { SettingsFunctionTypeEditRoute_GetByIdDocument } from "../queries.generated";

export default function useSettingsFunctionTypeEditRoute_GetById(functionTypeId: string) {
    const { data, loading, error } = useQuery(SettingsFunctionTypeEditRoute_GetByIdDocument, {
        variables: { id: functionTypeId },
    });

    return {
        functionType: data?.settingsEcologicalFunctionTypeGetById,
        loading,
        error,
    };
}
